import { type CustomTableType, type CustomFieldId, type CustomFieldListInput } from '@terros/common'
import { type QueryKey } from '@tanstack/react-query'

export const customFieldsKey = (
  tableType?: CustomTableType,
  input?: Omit<CustomFieldListInput, 'tableType'>
): QueryKey => {
  if (!tableType) return ['custom-fields']
  if (!input) return ['custom-fields', tableType]
  return ['custom-fields', tableType, input]
}
export const customFieldKey = (fieldId: CustomFieldId): QueryKey => ['custom-field', fieldId]
